<template>
  <div v-loading="loading">
    <el-table
      v-if="tableConfig"
      :key="tableKey"
      :data="docketBooks.data"
      style="width: 100%"
      row-key="id"
      @sort-change="handleSortChange"
    >
      <component
        :is="column.value"
        v-for="column in tableConfig.columns"
        :key="column.value"
      />
      <el-table-column
        fixed="right"
        label=""
        width="180"
        style="text-align: right;"
      >
        <template
          slot="header"
          slot-scope="scope"
        >
          <table-settings
            v-if="tableConfig"
            :config="tableConfig"
            :allcolumns="allColumns"
            :labels="labels"
            store-module="docketBook"
            :options="['settings']"
          />
        </template>
        <template
          slot-scope="scope"
        >
          <Actions :docket-book="scope.row" />
        </template>
      </el-table-column>
    </el-table>
    <div class="el-card-footer">
      <el-pagination
        background
        :current-page.sync="currentPage"
        :page-sizes="[20, 50, 100, 200]"
        :page-size="docketBooks.per_page"
        layout="total, prev, pager, next"
        :total="docketBooks.total"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
  import Actions from './Actions';
  import TableSettings from '../../TableSettings';
  import columns, { allColumns, labels } from './columns';

  export default {
    components: {
      Actions,
      TableSettings,
      ...columns,
    },
    data() {
      return {
        labels,
        allColumns,
        tableKey: 0,
        currentPage: 1,
        currentSort: {
          prop: 'created_at',
          order: 'descending',
        },
      };
    },
    computed: {
      docketBooks() {
        return this.$store.getters['docketBook/docketBooks'];
      },
      tableConfig() {
        return JSON.parse(JSON.stringify(this.$store.getters['docketBook/tableConfig']));
      },
      loading() {
        return this.$store.getters['docketBook/loading'];
      },
    },
    watch: {
      tableConfig() {
        this.tableKey++;
      },
    },
    async mounted() {
      this.$store.commit('docketBook/setFilterString', '');
      this.$store.commit('docketBook/setCurrentPage', this.currentPage);
      this.$store.commit('docketBook/setSorting', this.currentSort);
      await this.$store.dispatch('docketBook/fetchAll');
    },
    methods: {
      handleCurrentChange(val) {
        this.$store.commit('docketBook/setCurrentPage', val);
        this.$store.dispatch('docketBook/fetchAll');
      },
      handleSortChange({ column, prop, order }) {
        if (column.sortable === 'custom') {
          this.$store.commit('docketBook/setSorting', { prop, order });
          this.$store.dispatch('docketBook/fetchAll');
        }
      },
    },
  };
</script>

